/// <amd-module name="SuiteCommerce.GridOrder.MatrixChildItem.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.MatrixChildItem.Model", ["require", "exports", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Configuration", "SuiteCommerce.GridOrder.Cell.Model"], function (require, exports, Utils_1, GridOrder_Configuration_1, GridOrder_Cell_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MatrixChildItemModel = /** @class */ (function (_super) {
        __extends(MatrixChildItemModel, _super);
        function MatrixChildItemModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatrixChildItemModel.prototype.quantityIsValid = function () {
            // It's an invalid number
            if (isNaN(this.quantity)) {
                return false;
            }
            // Minimum quantity is not reached
            if (this.quantity && this.minimumQuantity && this.quantity < this.minimumQuantity) {
                return false;
            }
            // Maximum quantity is exceeded
            if (this.quantity && this.maximumQuantity && this.quantity > this.maximumQuantity) {
                return false;
            }
            return true;
        };
        MatrixChildItemModel.prototype.getErrorMessage = function () {
            // It's an invalid number
            if (isNaN(this.quantity)) {
                return Utils_1.Utils.translate('Please enter a valid number');
            }
            // Minimum quantity is not reached
            if (this.quantity && this.minimumQuantity && this.quantity < this.minimumQuantity) {
                var minimumQuantityHintMessage = GridOrder_Configuration_1.GridOrderConfiguration.minimumQuantityHint.replace('[[min]]', "" + this.minimumQuantity);
                return minimumQuantityHintMessage;
            }
            // Maximum quantity is exceeded
            if (this.quantity && this.maximumQuantity && this.quantity > this.maximumQuantity) {
                var maximumQuantityHintMessage = GridOrder_Configuration_1.GridOrderConfiguration.maximumQuantityHint.replace('[[max]]', "" + this.maximumQuantity);
                return maximumQuantityHintMessage;
            }
            return true;
        };
        return MatrixChildItemModel;
    }(GridOrder_Cell_Model_1.CellModel));
    exports.MatrixChildItemModel = MatrixChildItemModel;
});
